module.exports = __webpack_public_path__ + "static/media/backIconWhiteColor.383f6606.svg";